import React from 'react'

export const PricingIllustration: React.FC = () => {
  return (
    <svg
      width="400"
      height="250"
      viewBox="0 0 400 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(50, 0)">
        {/* 信用卡 */}
        <rect x="0" y="50" width="220" height="140" rx="12" fill="#12B9C0" />
        <rect x="20" y="100" width="50" height="10" rx="5" fill="white" />
        <rect x="20" y="120" width="80" height="10" rx="5" fill="white" />
        <rect x="20" y="140" width="40" height="10" rx="5" fill="white" />
        <rect x="120" y="140" width="60" height="10" rx="5" fill="white" />
        <circle cx="190" cy="80" r="20" fill="#FFC043" />

        {/* 收据/纸张 */}
        <rect
          x="180"
          y="10"
          width="100"
          height="120"
          rx="5"
          fill="white"
          transform="rotate(15)"
        />
        <line
          x1="190"
          y1="40"
          x2="270"
          y2="40"
          stroke="#E0E0E0"
          strokeWidth="2"
          transform="rotate(15)"
        />
        <line
          x1="190"
          y1="60"
          x2="270"
          y2="60"
          stroke="#E0E0E0"
          strokeWidth="2"
          transform="rotate(15)"
        />
        <line
          x1="190"
          y1="80"
          x2="270"
          y2="80"
          stroke="#E0E0E0"
          strokeWidth="2"
          transform="rotate(15)"
        />

        {/* 硬币 */}
        <circle cx="240" cy="150" r="25" fill="#FFC043" />
        <circle cx="240" cy="150" r="20" fill="#FFD470" />
        <circle cx="260" cy="180" r="20" fill="#FFC043" />
        <circle cx="260" cy="180" r="15" fill="#FFD470" />
        <circle cx="280" cy="150" r="15" fill="#12B9C0" />
      </g>
    </svg>
  )
}

export default PricingIllustration
